import React from "react";
const HelperBoxLabel = ({ label, forId, title, children }) => {
    const [isExpanded, setIsExpanded] = React.useState(false);
    const iconClass = isExpanded
        ? "icon-helper-close no-margin"
        : "icon-helper-open no-margin";
    return (React.createElement("div", { "data-ecom-helperbox": "label", className: "m-t-half m-b-half" },
        React.createElement("button", { title: label, className: "helper-box-header", onClick: () => setIsExpanded(!isExpanded) },
            React.createElement("label", { "data-ecom-inputlabel": "no-margin", htmlFor: forId }, label),
            React.createElement("div", { className: "helper-box-label" },
                React.createElement("i", { className: iconClass }))),
        isExpanded && (React.createElement("div", { className: "content" },
            !!title && (React.createElement("div", { className: "font-medium m-b-half" }, title)),
            React.createElement("div", { "data-ecom-content": "", className: "font-size-small" }, children)))));
};
export default HelperBoxLabel;
